import { useEffect, useState } from "react";
import whiteMark from "@/assets/dd-mark-white-transparent.png";
import navyMark from "@/assets/dd-mark-navy-transparent.png";

// Transparent brand marks that float directly on the surface (no tile/box/rounding).
// White mark on dark surfaces, navy mark on light. A surface counts as dark when the
// explicit `dark` prop is set OR the authenticated app theme is active
// (html.theme-dark, toggled per-route in App.js — which re-skins white headers to navy).
export function Logo({ className = "", showText = true, size = 22, dark = false }) {
  const [themeDark, setThemeDark] = useState(
    () => typeof document !== "undefined" && document.documentElement.classList.contains("theme-dark")
  );
  useEffect(() => {
    const el = document.documentElement;
    const update = () => setThemeDark(el.classList.contains("theme-dark"));
    update();
    const obs = new MutationObserver(update);
    obs.observe(el, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);

  const isDark = dark || themeDark;
  const dim = size + 12;
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img
        src={isDark ? whiteMark : navyMark}
        alt="TenantSeal"
        width={dim}
        height={dim}
        style={{ width: dim, height: dim }}
        className="shrink-0 select-none object-contain"
        draggable={false}
      />
      {showText && (
        <span className={`font-heading font-bold tracking-tight text-lg ${isDark ? "text-white" : "text-navy"}`}>
          Tenant<span className="text-brand">Seal</span>
        </span>
      )}
    </div>
  );
}
